<template
  lang="pug"
  functional
>
a.hover-link(
  v-if="props.enabled"
  v-tooltip="props.tooltip"
  :href="props.href"
  v-bind="data.attrs"
  :title="props.title"
  v-on="listeners"
)
  slot
  i(:class="{ [props.icon]: true, edit: true }")
span(v-else)
  slot
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
    href: {
      type: String,
    },
    title: {
      type: String,
    },
    tooltip: {
      type: Object,
      default: () => ({ placement: 'right', delay: { show: 1200, hide: 0 } }),
    },
    icon: {
      type: String,
      default: 'hi hi-edit-xs',
    },
  },
};
</script>
